import React, { useCallback, useState } from "react";
import { UiBox, UiSimpleGrid, UiWrap, useBreakpointValue } from "~/components/elements";
import ResultImageView from "~/components/modals/ResultImageView";
import { EChevronType } from "~/types/general";
import { ResultImagesApiItem } from "~/types/models/dashboard";
import { trackWindowScroll } from "react-lazy-load-image-component";
import { ImageThumbnail } from "~/pages/result-detail/components/ImageThumbnail";

interface GalleryForHeadshotStyleProps {
  galleryImages?: ResultImagesApiItem[];
  scrollPosition: any;
}

function ResultGalleryForHeadshotStyle({ galleryImages, scrollPosition }: GalleryForHeadshotStyleProps) {
  const [openModal, setOpenModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState<ResultImagesApiItem>();
  const [imageNth, setImageNth] = useState(0);
  const Container = useBreakpointValue<any>({ base: UiSimpleGrid, sm: UiWrap });

  const handleOnClickChevron = useCallback(
    (chevronType: EChevronType) => {
      const currentImageIndex = galleryImages?.findIndex(o => o.id === selectedImage?.id);
      if (galleryImages && currentImageIndex !== undefined) {
        if (chevronType === EChevronType.Next && currentImageIndex < galleryImages.length - 1) {
          setSelectedImage(galleryImages[currentImageIndex + 1]);
          setImageNth(currentImageIndex + 2);
        }
        if (chevronType === EChevronType.Previous && currentImageIndex > 0) {
          setSelectedImage(galleryImages[currentImageIndex - 1]);
          setImageNth(currentImageIndex);
        }
      }
    },
    [galleryImages, selectedImage?.id]
  );

  const onClickImageThumbnail = useCallback((image: ResultImagesApiItem, idx: number) => {
    setSelectedImage(image);
    setImageNth(idx + 1);
    setOpenModal(true);
  }, []);

  return (
    <UiBox>
      <ResultImageView
        imageSrc={selectedImage?.image_url}
        handleOnClickChevron={handleOnClickChevron}
        visible={openModal}
        totalItems={galleryImages?.length}
        itemNth={imageNth}
        onClose={() => setOpenModal(false)}
      />
      <Container w="full" spacing="1rem" justify="flex-start" columns={2}>
        {galleryImages?.map((image, idx) => (
          <ImageThumbnail
            key={image.id}
            imageId={image.id}
            scrollPosition={scrollPosition}
            idx={idx}
            onClick={onClickImageThumbnail}
          />
        ))}
      </Container>
    </UiBox>
  );
}

export default trackWindowScroll(ResultGalleryForHeadshotStyle);
